import { motion } from "framer-motion";
import { useSiatMotion, viewportOnce } from "./motion";

export function MotionReveal({
  as = "div",
  children,
  className,
  delay = 0,
  variant = "fadeUp",
  ...rest
}) {
  const { fadeUp, scaleIn, reduce } = useSiatMotion();
  const variants = variant === "scaleIn" ? scaleIn : fadeUp;
  const Component = motion[as] || motion.div;

  return (
    <Component
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={viewportOnce}
      transition={reduce ? { duration: 0 } : { delay }}
      {...rest}
    >
      {children}
    </Component>
  );
}

export function MotionStagger({ as = "div", children, className, ...rest }) {
  const { stagger } = useSiatMotion();
  const Component = motion[as] || motion.div;

  return (
    <Component
      className={className}
      variants={stagger}
      initial="hidden"
      whileInView="show"
      viewport={viewportOnce}
      {...rest}
    >
      {children}
    </Component>
  );
}

export function MotionItem({ as = "div", children, className, ...rest }) {
  const { fadeUp } = useSiatMotion();
  const Component = motion[as] || motion.div;

  return (
    <Component className={className} variants={fadeUp} {...rest}>
      {children}
    </Component>
  );
}
